import React from 'react';
import Skeleton from '../../../utils/components/Skeleton';

export default function BillingActivitySkeleton() {
  return (
    <>
      <div className="billings">
        <Skeleton containerClass="card--side"/>
        <Skeleton containerClass="invoices"/>
      </div>
    </>
  )
}